import {
  buildAdminListQuery,
  type TAdminListParams,
} from '@/core/lib/table-query'

export const questionEndpoints = {
  list: (params: TAdminListParams) =>
    `/admin/questions?${buildAdminListQuery(params)}`, // GET
  create: '/admin/questions', // POST
  import: '/admin/questions/import', // POST
  detail: (id: string) => `/admin/questions/${id}`, // GET
  edit: (id: string) => `/admin/questions/${id}`, // PATCH
  delete: (id: string) => `/admin/questions/${id}`, // DELETE
}

export const questionBackendErrors = {
  QUESTION_NOT_FOUND: 'Soru bulunamadı!',
  QUESTION_EXISTS: 'Bu soru çoktan oluşturulmuş!',
  QUESTION_CREATE: 'Soru oluşturulurken hata oluştu!',
  QUESTION_CHOICES_DUPLICATES: 'Soru içinde tekrar eden cevaplar mevcut!',
  QUESTION_CORRECT_OPTION_NOT_IN_CHOICES:
    'Doğru cevap, girilen cevaplardan biri olması zorunludur!',
  QUESTION_INVALID_CHOICES_COUNT: 'Toplamda 4 adet cevap girilmesi zorunludur!',
  INVALID_FORMAT: 'Yüklenilen dosyanın formatı xlsx veya csv olmalıdır!',
  /* v8 ignore next 2 */
  QUESTION_FIELD_REQUIRED: (args: string) =>
    `${args.split('_')?.[0]}.satırda ${args.split('_')?.[1]} alanı eksik!`,
  QUESTION_COLUMN_REQUIRED: 'Dosyada eksik sütun mevcut!',
  QUESTION_HEADER_REQUIRED: 'Dosyada eksik başlık mevcut!',
  QUESTION_EXCEED_LIMIT:
    'Tek seferde en fazla 100 soru içeri aktarabilirsiniz!',
  QUESTION_CATEGORY_NOT_FOUND:
    'Seçtiğiniz kategori mevcut değil veya silinmiş!',
  CATEGORY_CATEGORY_NOT_FOUND:
    'Seçtiğiniz kategori mevcut değil veya silinmiş!',
  CATEGORY_REQUIRED: 'Kategori seçilmesi zorunludur!',
  SUBCATEGORY_NOT_FOUND: 'Seçtiğiniz alt kategori mevcut değil veya silinmiş!',
  SUBCATEGORY_MISMATCH:
    'Seçtiğiniz alt kategori, seçilen kategoriye ait değil!',
  QUESTION_POOL_NOT_FOUND: 'Seçtiğiniz soru havuzu mevcut değil veya silinmiş!',
  QUESTION_POOL_PASSIVE:
    'Pasif soru havuzlarına yeni soru eklenemez. Önce havuzu aktif duruma getirin!',
  QUESTION_WARNING_NOT_INSERTED_ROWS: 'Bazı sorular içeri aktarılamadı!',
  QUESTION_EDIT: 'Soru düzenlenirken hata oluştu!',
  QUESTION_DELETE: 'Soru silinirken hata oluştu!',
  GENERAL_ERROR: 'Beklenemeyen bir hata oluştu!',
}

export const questionSuccessMessages = {
  questionCreate: 'Soru başarıyla oluşturuldu!',
  questionImport: 'Sorular başarıyla sisteme aktarıldı!',
  questionEdit: 'Soru başarıyla düzenlendi!',
  questionDelete: 'Soru başarıyla silindi!',
}

export const bulkImportArgs = {
  question: 'soru',
  first_choice: '1.cevap',
  second_choice: '2.cevap',
  third_choice: '3.cevap',
  fourth_choice: '4.cevap',
  correct_choice: 'doğru cevap',
}

export const questionDifficultyOptions = {
  VERY_EASY: 'Çok Kolay',
  EASY: 'Kolay',
  NORMAL: 'Normal',
  HARD: 'Zor',
  VERY_HARD: 'Çok Zor',
} as const

export const questionModeOptions = {
  CASUAL: 'Eğlence',
  RANKED: 'Bilgi Ligi',
} as const
